var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "90vh"
            }
          },
          on: {
            hide: function($event) {
              return _vm.hideModalListPlaylist("no-playlist")
            }
          },
          model: {
            value: _vm.show_modal_playlist,
            callback: function($$v) {
              _vm.show_modal_playlist = $$v
            },
            expression: "show_modal_playlist"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideModalListPlaylist("no-playlist")
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("playlists")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    attrs: {
                      data: _vm.podcasts,
                      columns: _vm.columns,
                      pagination: _vm.server_pagination,
                      loading: _vm.loading,
                      filter: _vm.filter,
                      "row-key": "name",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.server_pagination = $event
                      },
                      request: _vm.fetchPlayList
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("q-search", {
                              attrs: {
                                icon: "far fa-search",
                                placeholder: _vm.$t("search"),
                                debounce: 500
                              },
                              model: {
                                value: _vm.filter,
                                callback: function($$v) {
                                  _vm.filter = $$v
                                },
                                expression: "filter"
                              }
                            }),
                            _c("div", { staticClass: "col" }),
                            _c("q-btn", {
                              attrs: {
                                color: "secondary",
                                icon: "far fa-plus",
                                label: _vm.$t("new_playlist")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.clickAddPlaylist()
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                { key: col.name, attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t(col.label)) +
                                      "\n                        "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                {
                                  key: "id",
                                  attrs: { "auto-width": "", props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.id) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "title", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.title) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "playlist", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.playlist) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "active", attrs: { props: props } },
                                [
                                  _c("q-btn", {
                                    attrs: {
                                      color: "primary",
                                      label: _vm.$t("add_playlist"),
                                      icon: "far fa-music"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.addPlaylist(props.row)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("add-playlist", {
        attrs: { show: _vm.show_modal_add_plalist },
        on: { hideModalPlayList: _vm.hideModalPlayList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }